import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import Button from "../Button/Button";

const JobCard = ({ job, pdfBasePath }) => {
  return (
    <div className="job-card">
      <div className="job-card-header">
        <h2>{job.title}</h2>
        <span className="job-type">{job.type}</span>
      </div>

      <div className="job-meta">
        <FaMapMarkerAlt /> <span>{job.location}</span>
      </div>

      <p className="job-description">{job.description}</p>

      <div className="job-buttons">
        <a href={job.applyLink} target="_blank" rel="noopener noreferrer">
          <Button
            text="Apply Now"
            size="discord"
          />
        </a>

        <a
          href={`${pdfBasePath}/${job.pdfFile}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            text="Read More"
            size="discord"
          />
        </a>
      </div>
    </div>
  );
};

export default JobCard;
